@if (activeStream.video && !activeStream.playerConfig?.externalPlayer && !activeStream.playerConfig?.showErrorScreen) {
  <mb-stream-player
    [autoplay]="true"
    [media]="activeStream.video"
    [stream]="activeStream"
    [transcript]="transcript"
    [showBackButton]="true"
    [allowPictureInPicture]="allowPictureInPicture"
    [isEmbedPlayer]="isEmbedPlayer"
    (backButton)="OnClosePlayer()"
    (streamStopped)="OnStopStream()"
    (shareStream)="onShareStream()"
    (openMedia)="onOpenMedia($event)"
    (streamErrorData)="setStreamPlayerConfig($event)"
  ></mb-stream-player>
}
@if (activeStream.playerConfig?.showErrorScreen) {
  <mb-stream-player-error
    [streamId]="activeStream.id"
    [streamStatus]="activeStream.status"
    [errorText]="$safeNavigationMigration(activeStream.playerConfig?.errorText)"
    (closeStreamPlayer)="OnClosePlayer()"
    (streamErrorData)="setStreamPlayerConfig($event)"
  ></mb-stream-player-error>
}
